import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ChartLoader from '../../Loaders/ChartLoader';
import Auth from '../../../shared/Auth';
import Axios from '../../../utils/axiosClient';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);

Highcharts.setOptions({
  global: {
    useUTC: false,
  },
});

class PermissibleLoading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: null,
      reinitialize: true,
      pointLocation: null,
    };
  }

  UNSAFE_componentWillMount() {
    this.getData(this.props.id);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.id !== this.props.id) {
      this.getData(nextProps.id);
    }
  }

  async getData(id) {
    this.setState({
      reinitialize: true,
    });
    const current = this;
    const checkToken = await Auth();
    if (checkToken) {
      Axios.get(`assethealth/assetpermissibleloadnew/${id}/1`)
        .then((response) => {
          if (response.data.statusCode === 200) {
            if (response.data.result.loadStream.length > 0) {
              const { UsedLifeInYears } = response.data.result.loadStream[0];
              const sortedLoadStream = response.data.result.loadStream.sort(
                (a, b) => (a.ReportedDateTime > b.ReportedDateTime ? 1 : -1)
              );
              const obj = {
                loadStream: sortedLoadStream,
              };
              current.drawChart(obj, UsedLifeInYears);
            } else {
              current.drawChart([], '');
            }
          } else {
            const obj = {
              loadStream: [],
              temperatureStream: [],
              units: {
                PowerUnit: '',
              },
            };

            this.drawChart(obj, '');
          }
        })
        .catch((error) => {
          const obj = {
            loadStream: [],
            temperatureStream: [],
            units: {
              PowerUnit: '',
            },
          };
          this.drawChart(obj, '');
          // current.setState({ reinitialize: false });
          console.log(error);
        });
    }
  }

  drawChart(data, UsedLifeInYears) {
    const OTI = [];
    const WTI = [];
    const AmbT = [];
    const LoadMult = [];
    const VApres = [];
    const VA2hr = [];
    const VAbase = [];
    const VAavl = [];
    let unit = '';
    if (data.loadStream.length > 0) {
      unit = data.loadStream[0].unit;
      //  const descValues = data.loadStream.sort((a, b) => Date.parse(b.ReportedDateTime) - Date.parse(a.ReportedDateTime));
      //  UsedLifeInYears =  descValues[0].UsedLifeInYears;
      data.loadStream.forEach(async (element) => {
        const tmstmp = Date.parse(element.ReportedDateTime.replace('', ' '));
        OTI.push([tmstmp, parseFloat(element.OTI)]);
        WTI.push([tmstmp, parseFloat(element.WTI)]);
        AmbT.push([tmstmp, parseFloat(element.AmbT)]);
        LoadMult.push([tmstmp, parseFloat(element.LoadMult)]);
        VApres.push([tmstmp, parseFloat(element.VApres)]);
        VA2hr.push([tmstmp, parseFloat(element.VA2hr)]);
        VAbase.push([tmstmp, parseFloat(element.VAbase)]);
        VAavl.push([tmstmp, parseFloat(element.VAavl)]);
      });
    }
    this.setState({
      options: {
        chart: {
          renderTo: 'PowerVsTimeForecastChartContainer',
          type: 'line',
          height: '500px',
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  enabled: false,
                },
              },
            },
          ],
        },
        rangeSelector: {
          buttons: [
            {
              type: 'day',
              count: 1,
              text: '1d',
            },
            {
              type: 'week',
              count: 1,
              text: '1w',
            },
            {
              type: 'month',
              count: 1,
              text: '1m',
            },
            {
              type: 'year',
              count: 1,
              text: '1y',
            },
            {
              type: 'ytd',
              text: 'YTD',
            },
            {
              type: 'all',
              text: 'All',
            },
          ],
          inputEnabled: true,
          selected: 0,
          inputBoxWidth: 75,
          inputBoxHeight: 18,
          buttonTheme: {
            height: 18,
            padding: 2,
            undefined: 0,
            width: 15,
            Index: 7,
          },
        },
        title: {
          text: this.props.title,
          style: {
            fontSize: '14px',
            fontWeight: '800',
          },
        },
        subtitle: {
          text: `Used Life In Years ${UsedLifeInYears}`,
        },
        xAxis: {
          type: 'datetime',
        },
        yAxis: [
          {
            title: {
              text: unit,
            },
          },
          {
            // Secondary yAxis
            title: {
              text: '°C',
            },
            opposite: false,
          },
        ],
        legend: {
          enabled: true,
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'bottom',
        },
        exporting: {
          enabled: true,
          buttons: {
            contextButton: {
              menuItems: [
                'downloadPNG',
                'downloadJPEG',
                'downloadPDF',
                'downloadSVG',
                'separator',
                'downloadCSV',
                'downloadXLS',
                'viewData',
              ],
            },
          },
        },
        navigator: {
          enabled: false,
          reversed: false,
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> <span> {series.userOptions.unit}</span><br/>',
          valueDecimals: 2,
          split: true,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: 'VApres',
            marker: { enabled: false, symbol: 'circle', radius: 2 },
            data: VApres,
            unit,
          },
          {
            name: 'VA2hr',
            marker: { enabled: false, symbol: 'circle', radius: 2 },
            data: VA2hr,
            unit,
          },
          {
            name: 'VAavl',
            marker: { enabled: false, symbol: 'circle', radius: 2 },
            data: VAavl,
            unit,
          },
          {
            name: 'VAbase',
            marker: { enabled: false, symbol: 'circle', radius: 2 },
            data: VAbase,
            unit,
          },
          {
            name: 'OTI',
            marker: { enabled: false, symbol: 'circle', radius: 2 },
            lineWidth: 3,
            yAxis: 1,
            data: OTI,
            unit: '°C',
          },
          {
            name: 'WTI',
            marker: { enabled: false, symbol: 'circle', radius: 2 },
            yAxis: 1,
            data: WTI,
            unit: '°C',
          },
        ],
      },
      reinitialize: false,
    });
  }

  render() {
    return (
      <div>
        {!this.state.reinitialize ? (
          <HighchartsReact
            highcharts={Highcharts}
            constructorType={'stockChart'}
            options={this.state.options}
          />
        ) : (
          <ChartLoader height="150" width="600" />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  widgetSetting: state.WidgetSettingReducer,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PermissibleLoading);
